export { default } from './withLocaleRedirect';
